import { useController } from '@framework/form/hooks/useController.ts';
import styled from 'styled-components';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { getWidgetProps } from '../common/util/getWidgetProps.ts';
import { type IHiddenWidget } from './IHiddenWidget.ts';

const HiddenComponent = styled.div`
  visibility: hidden;
`;

export interface IHiddenWidgetComponentProps
  extends IWidgetComponentProps<IHiddenWidget> {}

export function HiddenWidgetComponent(props: IHiddenWidgetComponentProps) {
  const { widget } = props;

  const options = getWidgetProps(props);

  const { field } = useController(options.name);

  return <HiddenComponent {...field} />;
}
